import React from "react";
import MainCont from "./MainCont";
import SideCont from "./SideCont";
import SideMenu from "./SideMenu";
import Footer from "../../component/footer";
function Developer() {
    return (
        <>
            <div className="row absolute-bg developer-sec">
                <div className="col-lg-3">
                    <SideMenu />
                </div>
                <div className="col-lg-6">
                    <MainCont />
                </div>
                <div className="col-lg-3">
                    <SideCont />
                </div>
            </div>
            {/* <Footer/> */}
        </>
    )
}
export default Developer;